<template>
    <div class="row">
        <div class="col-4">
            <div class="member-title">Invitations</div>
            <div class="member-subtitle">You've sent these invitations for people to join your team. Remind them to check their emails to activate MagnusTeams.</div>
        </div>
        <div class="col-8 card p-0">
            <div class="card-body p-0">
                <template v-if="data && data.length > 0">
                    <div class="table-responsive">
                        <table class="table table-hover">
                            <thead>
                            <tr>
                                <th>Email</th>
                                <th>Role</th>
                                <th width="116"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="invitation in data" v-bind:key="invitation.id">
                                <td>
                                    {{ invitation.email }}
                                </td>
                                <td style="text-transform: capitalize">
                                    {{ invitation.team_member_profession }}
                                </td>
                                <td style="white-space: nowrap; text-align: right">
                                    <a class="me-2" href="#" @click="deleteInvitation(invitation)">
                                        <inline-svg src="/assets/img/icons/trash-01.svg"></inline-svg>
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InvitationsTable',
    props: ['value', 'role', 'data'],
    data() {
        return {
            loading: {
                delete: false,
            },
            options: [],
        };
    },
    methods: {
        deleteInvitation(invitation) {
            const self = this;
            this.$dialog.confirm('Are you sure you want to delete invitation?', {
                okText: 'Yes',
                cancelText: 'No',
            }).then(() => {
                self.loading.delete = true;
                self.$http.post("/hero/delete-invitation", invitation)
                    .then(() => {
                        self.$events.emit('loadInvitations');
                        self.loading.delete = false;
                    })
                    .catch(() => {
                        self.loading.delete = false;
                    });
            });
        },
    },
};
</script>
